<template>
  <transition name="slide-fade">

  <div class="login">
      <div class="login-bg register-bg"></div>

      <main class="main" v-if="!success">

        <router-link to="login"><img src="~@/assets/images/logo-full-mono-light.png" alt=""></router-link>
        <h1>Research Participant Registration</h1>

        <div class="box" >

          <template v-if="step == 1">
            <div class="row">
              <div class="col-12 typeTitle" >
                For privacy reasons all individuals using Microba’s services are required to have their own Microba account with a unique email address. This includes minors and other dependents.
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-12">
                <strong style="font-weight:900">Please make a selection below that suits the use of this account:</strong>
              </div>
            </div>

            <transition name="slide-fade">
              <div class="mt-3 mb-3">
                <div v-if="errorAdult" class="alert alert-danger w-100" role="alert">
                  A selection is required
                </div>
              </div>
            </transition>

            <div class="row mt-3">
              <div class="col-12">
                <div class="optionBox w-100"  :class="{ 'active' : underAge == 'adult' }" @click="underAge = 'adult'">
                  <div class="form-radio">
                    <input type="radio" v-model="underAge" id="underAge1" value="adult">
                    <label style="font-weight:900" for="underAge1">This account is for me, I am over 18 years of age</label>
                  </div>
                  <p class="radioHint">This account type is for a user who is 18 years of age or older. Samples provided under this account must be for this individual only.</p>
                </div>
              </div>
            </div>

            <div class="row mt-3">
              <div class="col-12">
                <div class="optionBox" :class="{ 'active' : underAge == 'parent' }" @click="underAge = 'parent'">
                  <div class="form-radio">
                    <input type="radio" v-model="underAge" id="underAge2" value="parent">
                    <label style="font-weight:900" for="underAge2">I will manage this account on behalf of my child or dependant</label>
                  </div>
                  <p class="radioHint">This account type is for a parent or guardian who will manage the account on behalf of one minor or dependant. Samples provided under this account must be for one individual minor or dependant only.</p>
                </div>
              </div>
            </div>

            <div class="row mt-3">
              <div class="col-12">
                <div class="optionBox" :class="{ 'active' : underAge == 'minor' }" @click="underAge = 'minor'">
                  <div class="form-radio">
                    <input type="radio" v-model="underAge" id="underAge3" value="minor">
                    <label style="font-weight:900" for="underAge3">I am under the age of 18, and will manage this account</label>
                  </div>
                  <p class="radioHint">This account type is for individuals under 18 years of age and will manage their own account. To access results parental/guardian consent will be required. All returned samples under this account must be for this individual only.</p>
                </div>
              </div>
            </div>

            <div class="row">
              <Button class="mb-0" text="Proceed" @onClick="onClickNext" :loading="isLoading" :success="success" />
            </div>



            <div class="row text-center no-account additional-info">
              <div class="col-12">
                <router-link to="login" class="text-center btn btn-outline-primary mt-3"><span class="text-muted">Already have an account?</span> Sign in</router-link>
              </div>
            </div>

          </template>
          <template v-else-if="step == 2">


            <div class="row mb-3">
              <div class="col">
              <strong>Please enter your details</strong>
              </div>
            </div>
            <div class="row">


              <transition name="slide-fade">
                <div class="col-12">
                  <div v-if="error" class="alert alert-danger" role="alert">
                    {{humanLoginError}}
                  </div>
                </div>
              </transition>

              <div class="form-group has-feedback has-feedback-left col-12 col-md-6" :class="{ 'has-danger' : errors.has('firstName') }">
                <label class="form-control-label hidden" for="firstName">First name</label>
                <div class="input-icon">
                  <span class="oi oi-person"></span>
                </div>
                <input type="text" class="form-control" :class="{ 'is-invalid' : errors.has('firstName') && fields.firstName.touched }" data-vv-as="first name" v-validate="'required'" v-model="firstName" name="firstName" id="firstName" placeholder="First Name">
                <div class="invalid-feedback" v-show="errors.has('firstName') && fields.firstName.touched">{{ errors.first('firstName') }}</div>
              </div>

              <div class="form-group has-feedback has-feedback-left col-12 col-md-6" :class="{ 'has-danger' : errors.has('lastName') }">
                <label class="form-control-label hidden" for="lastName">Last name</label>
                <div class="input-icon">
                  <span class="oi oi-person"></span>
                </div>
                <input type="text" class="form-control" :class="{ 'is-invalid' : errors.has('lastName') && fields.lastName.touched }" data-vv-as="last name" v-validate="'required'" v-model="lastName" name="lastName" id="lastName" placeholder="Last Name">
                <div class="invalid-feedback" v-show="errors.has('lastName') && fields.lastName.touched">{{ errors.first('lastName') }}</div>
              </div>

              <div class="form-group has-feedback has-feedback-left col-12" :class="{ 'has-danger' : errors.has('email') }">
                <label class="form-control-label hidden" for="inputEmail">Email</label>
                <div class="input-icon">
                  <span class="oi oi-envelope-closed"></span>
                </div>
                <input type="email" :class="{ 'is-invalid' : errors.has('email') && fields.email.touched }" class="form-control" v-validate="'required|email'" data-vv-as="email" v-model="email" name="email" id="inputEmail" placeholder="Email">
                <div class="invalid-feedback" v-show="errors.has('email')">{{ errors.first('email') }}</div>
                <!--<small class="form-text text-muted">We'll never share your email with anyone else.</small>-->
              </div>
              <div class="form-group has-feedback has-feedback-left col-12" :class="{ 'has-danger' : errors.has('email') }">
                <label class="form-control-label hidden" for="inputEmail">Confirm Email</label>
                <div class="input-icon">
                  <span class="oi oi-envelope-closed"></span>
                </div>
                <input type="email" :class="{ 'is-invalid' : errors.has('emailConfirm') && fields.emailConfirm.touched }" class="form-control" v-validate="{ is: email }" data-vv-as="Email confirmation" v-model="emailConfirm" name="emailConfirm" id="inputEmail" placeholder="Email Confirmation">
                <div class="invalid-feedback" v-show="errors.has('emailConfirm')">{{ errors.first('emailConfirm') }}</div>
                <!--<small class="form-text text-muted">We'll never share your email with anyone else.</small>-->
              </div>

              <div class="form-group has-feedback has-feedback-left col-12" :class="{ 'has-danger' : errors.has('password') }">
                <label class="form-control-label hidden" for="password">Password</label>
                <div class="input-icon">
                  <span class="oi oi-lock-locked"></span>
                </div>
                <input type="password" :class="{ 'is-invalid' : errors.has('password')  && fields.password.touched  }" class="form-control" v-validate="'required|min:8'" v-model="password" name="password" id="password" placeholder="Password">
                <div class="invalid-feedback" v-show="errors.has('password')">{{ errors.first('password') }}</div>
              </div>

            </div>
            <div class="row">
              <Button text="Create account" @onClick="onClickSave" :loading="isLoading" :success="success" />
            </div>

            <div class="row text-center no-account additional-info">
              <div class="col-12">
                <p class="text-center"><a @click="onClickBack">Back</a></p>
              </div>
            </div>

            <div class="row text-center no-account additional-info">
              <div class="col-12">
                <p class="text-center">Already have an account? <router-link to="login">Sign in</router-link></p>
              </div>
            </div>

          </template>
          <template v-else>


            <div class="row mb-3">
              <div class="col">
                <p>With your help, Microba and its research partners are working to build a deeper understanding of the human microbiome to drive innovation in health care.</p>
                <p>Please register for your Research Account below by entering the Participant code that has been supplied to you.</p>
              </div>
            </div>

            <transition name="slide-fade">
              <div v-if="fromVerify && !loginError" class="alert alert-success" role="alert">
                Thank you for verifying your account. Please sign in below.
              </div>
            </transition>

            <transition name="slide-fade">
              <div v-if="loginError" class="alert alert-danger" role="alert">
                {{humanLoginError}}
              </div>
            </transition>


            <transition name="slide-fade">
              <div v-if="!projectValid" class="alert alert-danger" role="alert">
                <span v-if="projectError == 409">A user with that email already exists. <router-link to="login"><span>Login instead</span></router-link>.</span>
                <span v-if="projectError == 400">Invalid participant code.</span>
                <span v-if="projectError == 404">Unable to find the participant code.</span>
              </div>
            </transition>

            <div class="form-group has-feedback has-feedback-left" :class="{ 'has-danger' : errors.has('email') }">
              <label class="form-control-label hidden" for="inputEmail">Participant Code</label>

              <input
                      type="text"
                      class="form-control form-control-danger"
                      v-model="projectCode"
                      name="projectCode"
                      placeholder="Participant code">
            </div>

            <!--<div class="form-group has-feedback has-feedback-left" :class="{ 'has-danger' : errors.has('email') }">-->
              <!--<label class="form-control-label hidden" for="inputEmail">Voucher Code</label>-->

              <!--<input-->
                      <!--type="text"-->
                      <!--class="form-control form-control-danger"-->
                      <!--v-model="voucherCode"-->
                      <!--name="voucherCode"-->
                      <!--placeholder="Voucher Code">-->
            <!--</div>-->

            <div class="form-group has-feedback has-feedback-left" :class="{ 'has-danger' : errors.has('email') }">
              <label class="form-control-label hidden" for="inputEmail">Email</label>
              <div class="input-icon">
                <span class="oi oi-envelope-closed"></span>
              </div>
              <input
                      type="email"
                      class="form-control form-control-danger"
                      v-model="email"
                      name="email"
                      placeholder="Email">
            </div>


            <div class="row text-center">
              <Button text="Proceed" @onClick="checkProject" :loading="projectLoading" />
            </div>

            <div class="row text-center no-account additional-info">
              <div class="col-12">
                <router-link to="login" class="text-center btn btn-outline-primary mt-3"><span class="text-muted">Already have a research account?</span> Sign in</router-link>
              </div>
            </div>

          </template>
        </div>



        <footer class="additional-info">
          <p>By creating an account, you are agreeing to our <a href="https://www.microba.com/wp-content/uploads/2018/12/Microba-Terms-Conditions-v2.8.pdf" target="_blank">Terms & Conditions</a> and <a href="https://www.microba.com/wp-content/uploads/2018/07/Microba-Pty-Limited-Privacy-Policy.pdf" target="_blank">Privacy Policy</a></p>
        </footer>



      </main>

      <transition name="slide-fade">
        <main class="main" v-if="success">
          <img src="~@/assets/images/logo-full-mono-light.png" alt="">
          <h1>Please check your email</h1>

          <div class="box row">
            <div class="col">
              <div class="alert alert-success" role="alert">
                <p>Thank you for registering.</p>
                <p>We have sent a confirmation email to {{this.email}}. Please follow the instructions in the email to activate your account.</p>
                </div>
            </div>
          </div>
        </main>
      </transition>

  </div>
  </transition>
</template>

<script>
import Button from '@/components/elements/DynamicButton.vue'

export default {
  name: 'Register',
  components: {
    Button
  },
  data () {
    return {
      isLoading: false,
      success: false,
      error: null,
      firstName: '',
      lastName: '',
      email: '',
      emailConfirm: '',
      password: '',
      underAge: null,
      step: 0,
      errorAdult: false,
      projectCode: '',
      voucherCode: '',
      projectLoading: false,
      projectValid: true,
      projectError: '',
      loginError: '',
      fromVerify: false
    }
  },

  computed: {
    isFullProfile: function () {
      return this.firstName && this.lastName && this.email && this.password && this.underAge
    },
    humanLoginError () {
      if (this.error.includes('User already exists')) {
        return 'Account already exists with this email address.'
      }
      return this.error
    }
  },

  methods: {
    onClickSave () {
      this.error = null
      if (this.errors.any() || !this.isFullProfile) {
        var fields = []
        if (!this.firstName) {
          fields.push('First name')
        }
        if (!this.lastName) {
          fields.push('Last name')
        }
        if (!this.email) {
          fields.push('Email')
        }
        if (!this.password || this.errors.has('password')) {
          fields.push('Password')
        }
        if (!this.underAge) {
          fields.push('Your age')
        }
        this.error = 'Please fill out ' + fields.join(', ')
      } else {
        this.signUp()
      }
    },

    checkVoucher () {

    },

    onClickNext () {
      if (this.underAge) {
        this.step++
      } else {
        this.errorAdult = true
      }
    },

    onClickBack () {
      this.step --
    },

    checkProject () {
      let self = this
      self.projectLoading = true
      self.projectValid = true
      let dataObj = {
        'participantIdentifier': self.projectCode,
        // 'voucherCode': self.voucherCode,
        'username': self.email
      }
      self.$store.dispatch('postProjectRegister', dataObj).then(() => {
        localStorage.setItem('redeem_on_register', JSON.stringify(dataObj))
        self.projectLoading = false
        self.step = 1
      }).catch(error => {
        if (error.response.status === 409) {
          localStorage.setItem('redeem_on_register', JSON.stringify(dataObj))
        }
        self.projectError = error.response.status
        self.projectLoading = false
        self.projectValid = false
      })
    },

    signUp () {
      this.isLoading = true
      this.$store.dispatch('postUser', {
        email: this.email,
        password: this.password,
        firstName: this.firstName,
        lastName: this.lastName,
        underAge: this.underAge !== 'adult',
        guardian: this.underAge === 'parent',
        userType: 'RESEARCH'
      }).then(() => {
        this.isLoading = false
        this.success = true
      }).catch(error => {
        this.isLoading = false
        this.success = false
        this.error = error.response.data.message
      })
    }
  },
  watch: {
    underAge () {
      this.errorAdult = false
    }
  }
}
</script>

<style scoped lang='scss'>

  body{
    background: white;
  }

  h1{
    /*font-size:20px;*/
    font-size: 2.3rem;
  }

  .box{
    color:#00193D;
    font-size:16px;
  }

  .optionBox{
    cursor:pointer;
    border: 0.5px solid #DBDBDB;
    border-radius: 5px;
    padding-left:20px;
    padding-top: 25px;
    padding-right: 26px;
  }

  .optionBox.active{
    background-color: #FFF7EE;
  }

  .optionBox:hover{
    border: 0.5px solid #ff8708;

  }


  .radio-wrapper-outer {
    width:100%;
    display:flex;
    justify-content:center;
    padding-top:1rem;
  }

  .radio-wrapper-inner {
    display:block;
  }

  .optionBox label {
    /*color: #ff8708 !important;*/
    color:#00193D;
    font-size:16px;
    margin-bottom:0px;
    padding-left:40px;
  }

  /*.form-radio label:before {*/
    /*top: 12px;*/
  /*}*/

  .radioHint{
    margin-left:40px;
    font-size: 14px;
    color: #778598;
  }

  .typeTitle{
    font-size: 20px;
    line-height: 1.75rem;
    color: #778598;
    margin-bottom: 0px;
  }

</style>



// WEBPACK FOOTER //
// src/application/research/Register.vue